<template>
  <v-dialog transition="fade-transition" scrollable
    v-model="$root.showlogin" 
    hide-overlay
    persistent 
    no-click-animation
    fullscreen class="noselect" 
    @click="CloseInfo()">
    <v-card style="overflow: hidden; position: relative;">
      <div id="particles-js"></div>
      <v-toolbar class="MyBackground" v-if="!comprando">
        <div class="d-flex flex-row justify-space-between align-center" style="width: 100%;">
          <div class="pointman" @click="BackHome()">
            <img
              v-if="$store.state.corpInfo.logo"
              :src="$root.UrlCorpImages + $store.state.corpInfo.logo"
              style="height: 38px; opacity: 1 !important;"
            />
          </div>
          <v-menu offset-y style="z-index: 99">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="menu-option" text :dark="$store.state.corpInfo.darkTheme" v-bind="attrs" v-on="on">
                <v-icon class="mr-1" style="font-size: 17px">
                  mdi-translate
                </v-icon>
                {{ $root.getTextlang() }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group mandatory v-model="$i18n.locale">
                <v-list-item
                  v-for="(lang, index) in $root.langs"
                  :key="`Lang${index}`"
                  :value="lang.locale"
                >
                  <v-list-item-title>{{ lang.text }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
        <v-spacer></v-spacer>
        <v-btn :dark="$store.state.corpInfo.darkTheme" @click="BackHome()" icon>
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0" style="height: 100vh;">
        <div class="infodata" v-if="showInfo">
          <div>
            <v-icon style="margin-top: -2px">mdi-clock-outline</v-icon>
            &nbsp;<strong>{{ $t("login.whatsThis.title") }}</strong>
          </div>
          <div>
            <br />
            {{ $t("login.whatsThis.text") }}
            <br /><br />
          </div>
          <div>
            <v-btn
              small
              style="font-size: 10px; width: 100%"
              color="var(--color-primary)"
              @click="CloseInfo()"
              dark
            >
              {{ $t("actions.understand") }}
            </v-btn>
          </div>3
        </div>
        <div class="myContainerCards" 
          :style="getStyle"
          >
          <div class="MyCard1">
            <FormLogin
              v-if="showLogin"
              @changeView="changeView"
              @BackHome="BackHome"
            />
            <FormNewUser
              v-if="showRegister"
              @changeView="changeView"
              @BackHome="BackHome"
            />
            <LostMyPass
              v-if="showLostPass"
              @changeView="changeView"
              @BackHome="BackHome"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import 'particles.js'
import jsonParticles from './particlesjs-config.json'
import FormLogin from "./FormLogin.vue";
import FormNewUser from "./FromNewUser.vue";
import LostMyPass from "./LostMyPass.vue";
import $ from "jquery";

export default {
  name: "login",
  props: ["comprando"],
  components: {
    FormLogin,
    FormNewUser,
    LostMyPass,
  },
  data() {
    return {
      showLogin: true,
      showRegister: false,
      showLostPass: false,
      showInfo: false,
      opt: 0
    };
  },
  computed: {
    getStyle: function () {
      let setStyle = {
        'background': `linear-gradient(
          to bottom, #000000 0%, var(--color-bg-others) 100%'}
        )`
      }
      if(this.$store.state.corpInfo.backgroundImage) {
        setStyle = {
          backgroundImage: `url(${this.$root.UrlCorpImages + this.$store.state.corpInfo.backgroundImage})`,
          'background-size': 'cover',
          'background-position': '50% 50%',
          'background-color': 'var(--color-bg-others)'
        }
      } else {
        setStyle = {
          'background': `linear-gradient(
            to bottom,
            ${this.$store.state.corpInfo.darkTheme ? 
            '#000000 0%, var(--color-bg-others) 100%':'#E2E6EF 0%, var(--color-bg-others) 100%'}
          )`
        }
      }
      return setStyle
    }
  },
  mounted() {
    this.showInfo = false;
    if (!this.isMobileDevice()) {
      window.particlesJS("particles-js", jsonParticles);
    }
  },
  methods: {
    isMobileDevice: function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    BackHome() {
      this.$root.showlogin = false;
      $('.DivMaster').show();
    },
    OpenInfo() {
      this.opt = 1;
      this.showInfo = true;
    },
    CloseInfo() {
      if (this.opt == 1) {
        this.opt = 0;
        return false;
      }
      this.showInfo = false;
    },
    changeView: function (val) {
      this.showLogin = false;
      this.showRegister = false;
      this.showLostPass = false;
      this[val] = true;
    },
  },
};
</script>

<style scoped>
.not-show {
  display: none;
}
.backShadow {
  width: 100%;
  height: 100%;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=0 );
 }
.infodata {
  z-index: 9;
  top: 50px;
  left: calc(100% - 280px);
  width: 240px;
  padding: 15px;
  border: 1px solid #cccc;
  border-radius: 5px;
  text-align: left;
  font-size: 11px;
}
.pointman:hover {
  cursor: pointer;
  opacity: 0.7;
}
.MyBackground {
  background: linear-gradient( 207deg, var(--color-primary-light) 0%, var(--color-primary) 45%, var(--color-primary-light1) 99% ) !important;
}

.myContainerCards {
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 20px 10px !important;
  background-size: cover;
  background-position: 50% 50%;
  background-blend-mode: multiply;
}

#particles-js {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}

.MyCard1 {
  max-height: 100%;
  max-width: 600px;
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, .2); 
  border-radius: 5px;
  backdrop-filter: blur(5px);
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

@media (max-width: 959px) {
  .myContainerCards {
    top: 56px;
  }
}
</style>